import { client } from '@/client/index'
import ENV_VARS from '@/global/environmentVariables'

client.setConfig({
  baseURL: ENV_VARS.CODEX_API_BASE_URL,
})

export const setupAuthInterceptor = (getAccessToken: () => Promise<string>) => {
  client.instance.interceptors.request.use(async (config) => {
    try {
      const accessToken = await getAccessToken()
      config.headers.set('Authorization', `Bearer ${accessToken}`)
    } catch (error) {
      console.error('Failed to get access token:', error)
    }
    return config
  })
}
